

import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { vibemartTheme } from "@/services/api/cresivoxServer";

export const getVibemartThemeTopCategory = createAsyncThunk<
  iGenericResponse<any> | null,
  void,
  { rejectValue: iStateMessage }
>(
  "getVibemartThemeTopCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await vibemartTheme.getVibemartThemeTopCategory();

     
      if (response?.httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        return response;
      }

      return rejectWithValue({
        httpStatusCode: response?.httpStatusCode,
        message: response?.errorMessage || "Failed to fetch top categories",
      });
    } catch (error: any) {
      return rejectWithValue({
        message: "Unexpected error occurred",
      });
    }
  }
);


export const addVibemartThemeTopCategory = createAsyncThunk<
  iGenericResponse<any> | null,
  { categoryId: string; priority: number },
  { rejectValue: iStateMessage }
>(
  "addVibemartThemeTopCategory",
  async ({ categoryId, priority }, { rejectWithValue }) => {
    try {
      const response =
        await vibemartTheme.addVibemartThemeTopCategory(
          categoryId,
          priority
        );
 
        
      if (response?.httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        return response;
      }

      return rejectWithValue({
        httpStatusCode: response?.httpStatusCode,
        message:response?.errorMessage || "Failed to update category priority",
      });
    } catch {
      return rejectWithValue({
        message: "Unexpected error occurred",
      });
    }
  }
);
